import axios from 'axios';
import { cmsUrl } from '../../variables';

export default {
    loadAllContributors(context) {
        context.commit('loadAllContributors');
        axios
            .get(cmsUrl + '/contributors')
            .then(data => context.commit('loadAllContributorsSuccess', data.data))
            .catch(err => context.commit('loadAllContributorsError', err))
    },
    selectContributorForDetail(context, payload) {
        context.commit('selectContributorForDetail', payload);
        if (!context.state.contributors.hasLoaded) {
            context.dispatch('loadAllContributors');
        }
    },
    selectContributorForAnswers(context, payload) {
        context.commit('selectContributorForAnswers', payload);
        if (!context.state.contributors.hasLoaded) {
            context.dispatch('loadAllContributors');
        }
    },

};